import { Component, ElementRef, OnInit, ViewChild, AfterViewChecked  } from '@angular/core';

import { BotService } from '../services/bot.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit, AfterViewChecked {
  newMessage: string = '';
  messageList: any[] =  [{ sender: 'bot', message: 'Ciao! 👋 Come posso aiutarti?' }];
  chatOpen = false;
  isLoading = false;
  environment = environment;
  @ViewChild('scrollAnchor') private scrollAnchor!: ElementRef;

  constructor(private botService: BotService) { }

  ngOnInit(): void {

  }

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.scrollAnchor.nativeElement.scrollIntoView({ behavior: 'smooth' });
    } catch (err) {}
  }

  toggleChat() {
    this.chatOpen = !this.chatOpen;
  }

  closeChat() {
    this.chatOpen = false;
  }

  sendMessage() {
    if (this.newMessage.trim() === '') return;
    this.isLoading = true;
    this.messageList.push({sender: 'user', message: this.newMessage.trim()});
    this.botService.sendMessage(this.newMessage.trim()).subscribe(
      data => {
        this.isLoading = false;
        if(this.botService.isEmpty() && data?.ws_id)
          this.botService.setSessionId(data.ws_id);
        if(data?.response)
          this.messageList.push({sender: 'bot', message: data.response});
      }
    );
    this.newMessage = '';
  }

  public formatMessage(message: string): string {
    return message ? message.replace(/\n/g, '<br>') : '';
  }

}
